<script lang="ts">
import Vue, { CreateElement, PropType, RenderContext, VNode } from 'vue';

import { Nullable } from '@/utils/types';

interface IProps {
  title: Nullable<string | number>;
}

// Keeps a long custom field value on one line in the list row; the full value shows on hover.
const CELL_STYLE = Object.freeze({ maxWidth: '250px' });

export default Vue.extend({
  name: 'CustomFieldCell',

  functional: true,

  props: {
    // The row's custom field value, shown as the tooltip. Null when the record has none.
    title: {
      type: [String, Number] as PropType<Nullable<string | number>>,
      default: null,
    },
  },

  render (h: CreateElement, { props, children, listeners }: RenderContext<IProps>): VNode {
    return h('div', {
      staticClass: 'custom-field-value text-truncate',
      style: CELL_STYLE,
      attrs: { title: props.title },
      on: listeners,
    }, children);
  },
});
</script>
